/**
 * @generated SignedSource<<135d9ee88b0b1d9eec5e4c33d1c49dd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutModule_viewer$data = {
  readonly isDyoEnabled: boolean | null;
  readonly " $fragmentType": "PdpRespAboutModule_viewer";
};
export type PdpRespAboutModule_viewer$key = {
  readonly " $data"?: PdpRespAboutModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutModule_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "29a5474102a05a4cdc530e0218acfe4d";

export default node;
